import { Socket } from "socket.io-client";
import ChatPacket from "./ChatPacket";

export default abstract class ClientChatPacket extends ChatPacket {
    public abstract send(socket: Socket);
}
